import Highcharts from "highcharts/highstock";
import Accessibility from "highcharts/modules/accessibility";
import HighchartsMap from "highcharts/modules/map";

/**
 * NOTE: HighchartsMap cannot be lazy-loaded when using highcharts/highstock as the base
 *
 * Lazy loading HighchartsMap (calling HighchartsMap(Highcharts) inside a component's useEffect)
 * causes conflicts with highcharts/highstock because:
 *
 * 1. Module initialization modifies the GLOBAL Highcharts/Highstock object
 * 2. When map charts are lazy-loaded, they modify Highstock after other chart types
 *    (like stock/benchmark charts) have already been initialized with the Highstock API
 * 3. This causes unpredictable behavior and breaks existing charts that depend on
 *    the original Highstock API (e.g., stockChart, chart methods)
 * 4. Different components initializing modules at different times leads to race conditions
 *
 *
 * @see https://www.highcharts.com/docs/getting-started/install-from-npm#2-load-highcharts-with-require
 * @see https://api.highcharts.com/highmaps/
 */
if (typeof Highcharts === "object") {
    if (typeof HighchartsMap === "function") {
        HighchartsMap(Highcharts);
    }

    if (typeof Accessibility === "function") {
        Accessibility(Highcharts);
    }
}

export default Highcharts;
